import { hasBillingIssue, allowBillingUpdatesForStatus } from '@/helpers/billing-helper'

const paymentMethods = state => {
  return state.paymentMethods
}

const defaultPaymentMethod = state => {
  return state.paymentMethods[0]
}

const subscriptions = state => {
  return state.subscriptions
}

const subscription = state => {
  return state.subscription
}

const currentBillingOrg = (state, getters, rootState, rootGetters) => {
  const selectedOrg = rootGetters['Permissions/currentSelectedOrg']
  const userOrgs = rootGetters['Users/currentUserOrgs']

  return userOrgs.find(org => org.id === selectedOrg.id) || {}
}

const currentOrgBillingEnabled = (state, getters, rootState, rootGetters) => {
  const currentOrg = getters.currentBillingOrg
  return currentOrg.billingEnabled && rootGetters['Permissions/canAdminSelectedOrg'] && allowBillingUpdatesForStatus(currentOrg.subStatus)
}

const currentOrgHasBillingIssue = (state, getters) => {
  return hasBillingIssue(getters.currentBillingOrg.subStatus)
}

const billingOrg = (state, getters, rootState, rootGetters) => (orgId) => {
  const userOrgs = rootGetters['Users/currentUserOrgs']
  orgId = parseInt(orgId, 10)

  return userOrgs.find(org => org.id === orgId) || {}
}

const orgBillingEnabled = (state, getters, rootState, rootGetters) => (orgId) => {
  const billingOrg = getters.billingOrg(orgId)
  return billingOrg.billingEnabled && rootGetters['Permissions/canAdminOrg'](orgId) && allowBillingUpdatesForStatus(billingOrg.subStatus)
}

const orgHasBillingIssue = (state, getters) => (orgId) => {
  const billingOrg = getters.billingOrg(orgId)
  return hasBillingIssue(billingOrg.subStatus)
}

export default {
  paymentMethods,
  defaultPaymentMethod,
  subscriptions,
  subscription,
  currentBillingOrg,
  currentOrgBillingEnabled,
  currentOrgHasBillingIssue,
  billingOrg,
  orgBillingEnabled,
  orgHasBillingIssue,
}
